import { computed } from 'vue';

function useSubformFieldProxy(formState, field, emit) {
	return computed({
		get: () => formState[field],
		set: value => emit('updateFormState', field, value),
	});
}

function useSubformFieldProxies(formState, fields, emit) {
	let result = {};
	fields.forEach(field => {
		result[field] = useSubformFieldProxy(formState, field, emit);
	});
	return result;
}

export {
	useSubformFieldProxy,
	useSubformFieldProxies,
}
